"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
class default_1 extends stimulus_1.Controller {
    connect() { }
    toggle(event) {
        this.itemTargets.forEach((item) => {
            item.hasAttribute("hidden") ? this.show(event) : this.hide(event);
        });
    }
    show(event) {
        this.itemTargets.forEach((item) => item.removeAttribute("hidden"));
    }
    hide(event) {
        this.itemTargets.forEach((item) => item.setAttribute("hidden", ""));
    }
}
exports.default = default_1;
default_1.targets = ["item"];
